// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"31":"735cb001","203":"9cc5127e","865":"629ec481"}[chunkId] + ".css";
};